export default __webpack_public_path__ + "static/other-2fb55675d67ad28a5d43ae8a2f07757d.png";